<template>
  <!-- Begin NER List -->
  <div class="flex justify-around items-center p-0 mb-1 rounded" :style="{background: background}">
    <input type="text" :value="value.toUpperCase()" @input="editText(idx, $event.target.value.toUpperCase())" class="w-full bg-gray-200 text-md m-2 rounded p-1" />
    <div class="mx-2 flex">
      <input class="prot m-1" v-model="checked" @change="checking(idx, checked)" type="checkbox" />
    </div>
  </div>
  <!-- End of NER List -->
</template>

<script>

export default {
  props: ['background', 'value', 'editText', 'idx', 'checking'],
  data() {
    return {
      checked: true,
      entities: '',
    }
  },
}
</script>

<style>
.prot {
  transform: scale(2)
}
</style>